import readRedesignRootAttribute from './readRedesignRootAttribute';
import isSafeUrl from './isSafeUrl';

function readRedesignFooterLinks() {
    const links = readRedesignRootAttribute('data-redesign-footer-links');
    if (!links || typeof links !== 'object') {
        return {};
    }

    const safeLinks = {};
    Object.keys(links).forEach((key) => {
        if (isSafeUrl(links[key])) {
            safeLinks[key] = links[key];
        }
    });

    return safeLinks;
}

export default readRedesignFooterLinks;
